export const LOGO_IMAGE = "/images/rolling.svg";
